import CopilotProvider from 'copilot-toolkit/CopilotProvider';
import { loginVerifyEcho } from './crm_ui/api/AuthRefreshAPI';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { setupTextInputPerformanceMeasuring } from 'customer-data-rte/config/InputPerformanceMeasuring';
import * as UsageLoggerRequiredData from './tracking/UsageLoggerRequiredData';
import CrmLogger from './loggers/crmLogger';
import { legacySetupData } from './setup/legacySetupData';
import { setupCurrentTeamsContainer } from './setup/setupCurrentTeamsContainer';
import { setupLimitsContainer } from './setup/setupLimitsContainer';
import { setupScopesContainer } from './setup/setupScopesContainer';
import { setupAuthContainer } from './setup/setupAuthContainer';
import { setupMyTeamContainer } from './setup/setupMyTeamContainer';
import Raven from 'raven-js';
import { delayUntilIdle } from './crm_ui/utils/delayUntilIdle';
import { Provider } from 'react-redux';
import { configureStore } from './rewrite/init/utils/configureStore';
import { appInit } from './rewrite/init/actions/initActions';
import { enableES5 } from 'immer';
import { ApolloProvider } from '@apollo/client';
import { createApolloClient } from 'hubspot-apollo-client';
import { ProvideDataFetchingClient } from './app/dataFetchingClient/DataFetchingClientProvider';
import { startOutdatedVersionPoll } from './crm_ui/utils/crmRefreshPoller';
import AlertSetup from './setup/AlertSetup';
import AppContainer from './AppContainer';
import { getSuperStoreInstance } from './rewrite/superstore/getSuperStoreInstance';
// @ts-expect-error untyped
import { FeedbackLoaderProvider } from 'feedback-loader/FeedbackLoaderProvider';
import { RenderApplicationToTableLoaded, RenderApplicationToIndexRoute, IndexRouteToIndexDataLoaderMounted, IndexDataLoaderToIndexPageMounted, TableQueryToAsyncTableMounted, TableQueryToTableMounted, IndexPageToBoardColumnMounted, IndexPageToBoardItemMounted, RenderApplicationToBoardLoaded, BoardQueryMountedToBoardLoaded } from 'crm-fe-perf/timing/measurements/crm-index-ui/performanceMeasurements';
import { CrmLinksDataProvider } from 'crm-links/common/context/CrmLinksDataProvider';
import CommandHandler from './CommandHandler';
import measure from 'crm-fe-perf/timing/measure';
import { setUpReportingPrimaryTracker } from './app/utils/setUpReportingPrimaryTracker';
import { setUpCommercePrimaryTracker } from './app/utils/setUpCommercePrimaryTracker';
import { enableEarlyCacheReturn } from 'framework-data-schema-resolvers/earlyCacheReturn';
import { predictAdditionalMetricsDimensions } from './lib/metrics/predictAdditionalMetricsDimensions';
import { preloadCodeSplits } from './rewrite/init/utils/preloadCodeSplits';
import Routes from './router/Routes';
import { getAuth } from 'quartz-core/framework/auth/app';
import { PropertiesProvider } from 'customer-data-properties/context';
import { createLaboratoryClient } from './experiments/laboratoryClient';
import { injectAppCuesScript, isAppCuesEnabled, setupAppCues } from './setup/setupAppCues';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const prepareApp = () => {
  // Set Raven to ignore errors when running in an iframe
  Raven.setShouldSendCallback(data => {
    // Don't send errors if the app is in an iframe
    const isInIframe = window.self !== window.top;
    if (isInIframe) {
      // eslint-disable-next-line no-console
      console.log('Error reporting suppressed in iframe:', data && data.message);
      return false;
    }
    return true;
  });
  preloadCodeSplits();
  // Configure immer
  // see also: https://immerjs.github.io/immer/docs/installation#pick-your-immer-version
  // TODO: Can we drop this now that we no longer need to support IE11?
  enableES5();

  // Enable FDSR's early cache return beahavior
  enableEarlyCacheReturn();

  // Initialize the superstore connection
  // TODO: The error handling here is excessive and should be cleaned up, but testing this function
  // is tricky.
  try {
    getSuperStoreInstance().catch(e => {
      Raven.captureException(e);
    });
  } catch (e) {
    Raven.captureException(e);
  }

  // Reporting Primary Tracker setup
  setUpReportingPrimaryTracker();

  // Commerce Primary Tracker setup
  setUpCommercePrimaryTracker();
  let appCuesPromise = null;
  if (isAppCuesEnabled()) {
    appCuesPromise = injectAppCuesScript();
  }

  // Create & configure redux store
  const store = configureStore();
  const apolloClient = createApolloClient({
    useBatched: true
  });
  const auth = getAuth();
  createLaboratoryClient(auth.user.user_id);

  // This adds a couple properties to all events.
  CrmLogger.init(UsageLoggerRequiredData.get());

  // HACK: inits IsUngatedStore (along with other AuthStores: UserStore and PortalStore).
  //       IsUngatedStore is required to render the preview sidebar (and any legacy code
  //       that checks for gates)
  legacySetupData(auth);

  // HACK: ScopesContainer is 100% required to render the rewrite
  setupScopesContainer(auth);

  // These containers are likely necessary, but it's not known if they are
  setupLimitsContainer(auth);
  setupCurrentTeamsContainer(auth);
  setupMyTeamContainer(auth);
  setupAuthContainer(auth);

  // Dispatch init action
  store.dispatch(appInit(auth));
  const onAfterRender = () => {
    delayUntilIdle(() => {
      setupTextInputPerformanceMeasuring();
      startOutdatedVersionPoll();
      AlertSetup.setup();
    });
    if (appCuesPromise) {
      setupAppCues(appCuesPromise, auth);
    }
    const LOGIN_VERIFY_ECHO_INTERVAL = 1800000;
    setInterval(loginVerifyEcho, LOGIN_VERIFY_ECHO_INTERVAL);
  };
  const metricsAdditionalDimensions = predictAdditionalMetricsDimensions();

  // Table measurements
  measure(RenderApplicationToTableLoaded, metricsAdditionalDimensions);
  measure(RenderApplicationToIndexRoute, metricsAdditionalDimensions);
  measure(IndexRouteToIndexDataLoaderMounted, metricsAdditionalDimensions);
  measure(IndexDataLoaderToIndexPageMounted, metricsAdditionalDimensions);
  measure(TableQueryToAsyncTableMounted, metricsAdditionalDimensions);
  measure(TableQueryToTableMounted, metricsAdditionalDimensions);
  // Board measurements
  measure(RenderApplicationToBoardLoaded, metricsAdditionalDimensions);
  measure(BoardQueryMountedToBoardLoaded, metricsAdditionalDimensions);
  /**
    Note: In some edge cases, the following measurements may not be accurate.
    We are clearing the start mark - IndexPageMounted - in the following cases:
    1. When the user navigates to the board view from the table view, we send a new mark.
    2. When all the columns are collapsed.
    3. When board is first loaded empty with a search query.
  */
  measure(IndexPageToBoardColumnMounted, metricsAdditionalDimensions);
  measure(IndexPageToBoardItemMounted, metricsAdditionalDimensions);
  return {
    onAfterRender,
    props: {
      apolloClient,
      store
    }
  };
};
export const AppComponent = ({
  apolloClient,
  store
}) => {
  return /*#__PURE__*/_jsx(ApolloProvider, {
    client: apolloClient,
    children: /*#__PURE__*/_jsx(ProvideDataFetchingClient, {
      children: /*#__PURE__*/_jsx(Provider, {
        store: store,
        children: /*#__PURE__*/_jsx(FeedbackLoaderProvider, {
          children: /*#__PURE__*/_jsx(CrmLinksDataProvider, {
            apolloClient: apolloClient,
            children: /*#__PURE__*/_jsx(CopilotProvider, {
              children: /*#__PURE__*/_jsx(PropertiesProvider, {
                children: /*#__PURE__*/_jsxs(AppContainer, {
                  children: [/*#__PURE__*/_jsx(Routes, {}), /*#__PURE__*/_jsx(CommandHandler, {})]
                })
              })
            })
          })
        })
      })
    })
  });
};